export default function AppSection() {
  return (
    <section id="app" className="bg-secondary-900 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[960px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-[2rem] bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center shadow-2xl shadow-primary-500/20">
              <div className="w-36 h-36 md:w-44 md:h-44 rounded-2xl bg-secondary-900/80 backdrop-blur flex flex-col items-center justify-center gap-2">
                <i className="ri-movie-2-line text-4xl md:text-5xl text-white"></i>
                <span className="text-lg md:text-xl font-heading font-bold">51电影网</span>
                <span className="text-[10px] text-secondary-400">随身影视追踪</span>
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-heading font-bold mb-4">
              移动客户端
            </h2>
            <p className="text-sm md:text-base text-secondary-300 leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              下载51电影网移动客户端，随时随地追踪电影上映动态、幕后花絮与明星八卦。
              推送即时票房黑马警报，不错过任何一个争议事件热点。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="px-6 py-3 bg-white text-secondary-900 font-semibold text-sm rounded-lg hover:bg-secondary-100 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-line mr-2"></i>
                App Store
              </a>
              <a
                href="#hero"
                className="px-6 py-3 bg-white/10 text-white font-semibold text-sm rounded-lg hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-line mr-2"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}